import {apiGetRequest,apiPostRequest,apiPostJsonRequest,apiPostFormDataRequest,apiPutRequest,apiDeleteRequest,downloadUrlRequest,apiGetFullUrlRequest} from '../http/http'
/**
 * 登录request**/
export const loginRequest = (userInfo)=>{
    return apiGetRequest('/lechun-baseservice/auth/login',userInfo)
}
/**
 * 获取登录验证码
 * **/
export const getLoginImageValidateCode = (param)=>{
    return apiGetRequest('/lechun-baseservice/auth/captcha',param)
}
/**
 * 登出request**/
export const loginOutRequest = (userInfo)=>{
    return apiPostRequest('/lechun-baseservice/auth/logout',userInfo)
}
/*
* aside菜单
* */
export const getSysUserMenu = (param)=>{
    return apiGetRequest('/lechun-baseservice/auth/getSysUserMenu',param)
}
/*
* header用户信息
* */
export const getUserDetail = (param)=>{
    return apiGetRequest('/lechun-baseservice/auth/getUserDetail',param)
}
/*
* Vibe 项目部署
* */
export const getMyVibeProjectSummary = (param)=>{
    return apiGetRequest('/lechun-baseservice/vibeProject/getMySummary',param)
}
export const applyMyGitlabAccount = (param)=>{
    return apiPostRequest('/lechun-baseservice/vibeProject/applyMyGitlabAccount',param)
}
export const getMyVibeProjectList = (param)=>{
    return apiGetRequest('/lechun-baseservice/vibeProject/getMyProjectList',param)
}
export const getAllVibeProjectList = (param)=>{
    return apiGetRequest('/lechun-baseservice/vibeProject/getAllProjectList',param)
}
export const getPortalVibeProjectList = (param)=>{
    return apiGetRequest('/lechun-baseservice/vibeProject/portal/projects',param)
}
export const getVibePageRouteSyncPrompt = (param)=>{
    return apiGetRequest('/lechun-baseservice/vibeProject/routes/syncPrompt',param)
}
export const previewVibeProjectDelete = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/vibeProject/delete/preview',param)
}
export const executeVibeProjectDelete = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/vibeProject/delete/execute',param)
}
export const getVibeProjectDeleteStatus = (param)=>{
    return apiGetRequest('/lechun-baseservice/vibeProject/delete/status',param)
}
export const retryVibeProjectDelete = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/vibeProject/delete/retry',param)
}
export const recommendVibeProjects = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/vibeProject/recommendProjects',param,70000)
}
export const authorizeMyVibeProject = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/vibeProject/authorizeMyProject',param)
}
export const getVibeProjectAuthorization = (param)=>{
    return apiGetRequest('/lechun-baseservice/vibeProject/getProjectAuthorization',param)
}
export const saveVibeProjectAuthorization = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/vibeProject/saveProjectAuthorization',param)
}
export const applyVibeProjectPermission = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/vibeProject/applyProjectPermission',param)
}
export const getMyVibeProjectPermissionRequestCount = (param)=>{
    return apiGetRequest('/lechun-baseservice/vibeProject/getMyProjectPermissionRequestCount',param)
}
export const getMyVibeProjectPermissionRequestList = (param)=>{
    return apiGetRequest('/lechun-baseservice/vibeProject/getMyProjectPermissionRequestList',param)
}
export const approveVibeProjectPermissionRequest = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/vibeProject/approveProjectPermissionRequest',param)
}
export const createMyVibeProject = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/vibeProject/createMyProject',param)
}
export const retryMyVibeProject = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/vibeProject/retryMyProject',param)
}
export const getMyVibeProjectDetail = (param)=>{
    return apiGetRequest('/lechun-baseservice/vibeProject/getMyProjectDetail',param)
}
export const getMyVibeDatasetDepartments = (param)=>{
    return apiGetRequest('/lechun-baseservice/vibeDataset/my/departments',param)
}
export const getMyVibeDatasetDetail = (param)=>{
    return apiGetRequest('/lechun-baseservice/vibeDataset/my/detail',param)
}
export const saveMyVibeDatasetSettings = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/vibeDataset/my/settings/save',param)
}
export const getMyVibeDatasetIngestions = (param)=>{
    return apiGetRequest('/lechun-baseservice/vibeDataset/my/ingestions',param)
}
export const getMyVibeDatasetIngestionErrors = ({ ingestionId, ...param })=>{
    return apiGetRequest(`/lechun-baseservice/vibeDataset/my/ingestions/${encodeURIComponent(ingestionId)}/errors`,param)
}
/*
* 修改密码
* */
export const updatePassWord = (param)=>{
    return apiPostRequest('/lechun-baseservice/user/updatePassWord',param)
}
/*
* 保存用户个人问数主题
* */
export const saveUserWenshuTopics = (param)=>{
    return apiPostRequest('/lechun-baseservice/user/saveUserWenshuTopics',param)
}
/*
* 保存用户个人 MCP 服务
* */
export const saveUserMcpServices = (param)=>{
    return apiPostRequest('/lechun-baseservice/user/saveUserMcpServices',param)
}
/*
* 菜单管理
* */
export const getMallResourceList = (param)=>{
    return apiGetRequest('/lechun-baseservice/resource/getMallResourceList',param)
}
/*
* 保存菜单
* */
export const saveMallResource = (param)=>{
    return apiPostRequest('/lechun-baseservice/resource/saveOrUpdateMallResource',param)
}
/*
* 用户管理
* */
export const getMallUserList = (param)=>{
    return apiGetRequest('/lechun-baseservice/user/getMallUserList',param)
}
/*
* 用户管理-获取部门
* */
export const getUserDeparts = (param)=>{
    return apiGetRequest('/lechun-baseservice/user/getDeparts',param)
}
/*
* 用户管理-获取下拉用户列表
* */
export const getUserListForDropbox = (param)=>{
    return apiGetRequest('/lechun-baseservice/user/getUserListForDorpbox',param)
}
/*
* 用户管理-获取所属公司
* */
export const getUserPlatForm = (param)=>{
    return apiGetRequest('/lechun-baseservice/comm/platFormList',param)
}
/*
* 用户管理-保存用户管理
* */
export const saveOrUpdateMallUser = (param)=>{
    return apiPostRequest('/lechun-baseservice/user/saveOrUpdateMallUser',param)
}
/*
* 用户管理-保存用户管理
* */
export const handleUpdateDingDingUser = (param)=>{
    return apiPostRequest('/lechun-baseservice/dingDeptStaff/syncDeptStaff',param)
}
/*
* 用户管理-删除用户
* */
export const deleteUserRole = (param)=>{
    return apiPostRequest('/lechun-baseservice/user/deleteUserRole',param)
}
/*
* 用户角色管理
* */
export const getMallUserRoleList = (param)=>{
    return apiGetRequest('/lechun-baseservice/user/getMallUserRoleList',param)
}
/*
* 保存用户角色管
* */
export const saveUserRole = (param)=>{
    return apiPostRequest('/lechun-baseservice/user/saveUserRole',param)
}
/*
* 角色列表
* */
export const getMallRoleList = (param)=>{
    return apiGetRequest('/lechun-baseservice/role/getMallRoleList',param)
}
/*
* 角色菜单权限列表
* */
export const getMallRoleResourceList = (param)=>{
    return apiGetRequest('/lechun-baseservice/role/getMallRoleResourceList',param)
}
/*
* 角色名称选项列表
* */
export const getMallRoleNameList = (param)=>{
    return apiGetRequest('/lechun-baseservice/role/getOptionalRoles',param)
}
/*
* 保存角色
* */
export const saveOrUpdateMallRole = (param)=>{
    return apiPostRequest('/lechun-baseservice/role/saveOrUpdateMallRole',param)
}/*
* 保存角色权限选择
* */
export const saveRoleResource = (param)=>{
    return apiPostRequest('/lechun-baseservice/role/saveRoleResource',param)
}
/**
 * 周笔记获取接口
 * **/
export const getCooperateList = (param)=>{
    return apiGetRequest('/lechun-baseservice/organization/getPaperPageList',param)
}

/**
 * 分销渠道获取权限列表
 * **/
export const getSalesRoleList = (param)=>{
    return apiGetRequest('/lechun-baseservice/role/getMallRoleDataList',param)
}
/**
 * 分销渠道获取权限类型
 * **/
export const getSalesTypeRoleList = (param)=>{
    return apiGetRequest('/lechun-baseservice/role/getDataTypes',param)
}
/**
 * 分销渠道获取权限类型
 * **/
export const saveRoleSalesResource = (param)=>{
    return apiPostRequest('/lechun-baseservice/role/saveRoleData',param)
}

/**
 * 测试验证
 * **/
export const getControlSystemList = (param)=>{
    return apiGetRequest('/lechun-baseservice/role/getControlSystems',param)
}
/**
 * 测试验证参数
 * **/
export const getControlSystemParam = (param)=>{
    return apiGetRequest('/lechun-baseservice/role/setTestAuthor',param)
}
/**
 * 获取接口频率监测概览
 * **/
export const getFrequencyMonitorOverview = (param)=>{
    return apiGetRequest('/lechun-gatewaynew/monitor/frequency/overview',param)
}
/**
 * 获取所有系统
 * **/
export const getBaseSystem = (param)=>{
    return apiGetRequest('/lechun-baseservice/resource/getBaseSystem',param)
}

/**
 * 测试验证保存
 * **/
export const saveControlSystem = (param)=>{
    return apiPostRequest('/lechun-baseservice/system/saveSystem',param)
}
/**
 * 观远bi单点登录
 * **/
export const gyBiSystemLogin = (param)=>{
    return apiGetRequest('/lechun-baseservice/sso/buildGuanyuanAccessTokenByLoginUser',param)
}
/**
 * 乐纯bi单点登录
 * **/
export const lcBiSystemLogin = (param)=>{
    return apiPostRequest('/lechun-baseservice/sso/buildMetaBaseAccessToken',param)
}
/**
 * 乐纯bi密码登录
 * **/
export const lcBiSystemLoginSubmit = (param)=>{
    return apiPostRequest('/lechun-baseservice/sso/saveMetaBasePassword',param)
}
/**
 * 观远bi iframe单点登录
 * **/
export const gyBiIframeLogin = (param)=>{
    return apiGetRequest('/lechun-baseservice/sso/buildGuanyuanAccessTokenNew',param)
}
/**
 * 获取消息列表
 * **/
export const getNotificationsList = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/portal/getUserMessageList',param)
}
/**
 * 获取消息数量
 * **/
export const getNotificationsCount = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/portal/getPortalCount',param)
}
/**
 * 获取消息选项列表
 * **/
export const getNotificationsOptions = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/portal/getMessageDictionary',param)
}

/**
 * 设置消息已读
 * **/
export const setNotificationsRead = (param)=>{
    return apiPostRequest('/lechun-baseservice/portal/readMessage',param)
}
/**
 * 处理消息
 * **/
export const handleNotifications = (param)=>{
    return apiPostRequest('/lechun-baseservice/portal/processMessage',param)
}
/**
 * 处理消息带链接
 * **/
export const handleLinkNotifications = (url)=>{
    return apiGetFullUrlRequest(url)
}
/**
 * 配置消息列表（后台）
 * **/
export const getConfigureMessageList = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/portal/getMessageList',param)
}
/**
 * 配置消息类型列表（后台）
 * **/
export const getConfigureClassMessageList = (param)=>{
    return apiPostRequest('/lechun-baseservice/portal/getMessageClassPageList',param)
}/**
 * 配置消息类型文件夹（后台）
 * **/
export const getConfigureClassMessageFolderList = (param)=>{
    return apiPostRequest('/lechun-baseservice/portal/getMessageClassFolderOptional',param)
}
/**
 * 配置消息类型详情（后台）
 * **/
export const getConfigureClassMessage = (param)=>{
    return apiPostRequest('/lechun-baseservice/portal/getMessageClass',param)
}
/**
 * 移动消息（后台）
 * **/
export const moveConfigureClassMessage = (param)=>{
    return apiPostRequest('/lechun-baseservice/portal/removeMessageClassPath',param)
}
/**
 * 复制消息（后台）
 * **/
export const copyConfigureClassMessage = (param)=>{
    return apiPostRequest('/lechun-baseservice/portal/copyMessageClass',param)
}
/**
 * 获取用户消息数据详情
 * **/
export const getNotificationsResultData = (param)=>{
    return apiGetRequest('/lechun-baseservice/portal/getUserMessageData',param)
}
/**
 * 获取消息数据详情
 * **/
export const getNotificationsMsgResultData = (param)=>{
    return apiGetRequest('/lechun-baseservice/portal/getMessageData',param)
}
/**
 * 配置消息类型详情（后台）
 * **/
export const getCronTimeData = (param)=>{
    return apiPostRequest('/lechun-baseservice/portal/getCronTime',param)
}
/**
 * 获取消息执行时间（后台）
 * **/
export const getInvokeMapKey = (param)=>{
    return apiPostRequest('/lechun-baseservice/portal/getInvokeMapKey',param)
}
/**
 * 保存消息类型(后台)
 * **/
export const saveNotificationData = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/portal/saveMessageClass',param)
}
/**
 * 删除消息类型(后台)
 * **/
export const delNotificationData = (param)=>{
    return apiPostRequest('/lechun-baseservice/portal/deleteMessageClass',param)
}
/**
 * 反馈字典列表
 * **/
export const getFeedbackDicList = (param)=>{
    return apiGetRequest('/lechun-baseservice/feedback/getDicList',param)
}
/**
 * 保存反馈
 * **/
export const saveFeedbackData = (param)=>{
    return apiPostRequest('/lechun-baseservice/feedback/saveFeedback',param)
}
/**
 * 处理反馈列表
 * **/
export const getSystemFeedbackList = (param)=>{
    return apiGetRequest('/lechun-baseservice/feedback/getSystemFeddbackList',param)
}
/**
 * 我的收藏
 * **/
export const getMyCollectData = (param)=>{
    return apiPostRequest('/lechun-baseservice/favorite/getFavoriteList',param)
}
/**
 * 保存收藏
 * **/
export const saveCollectData = (param)=>{
    return apiPostRequest('/lechun-baseservice/favorite/saveFavorite',param)
}

/**
 * 获取日历（后台）
 * **/
export const getCalendarDataList = (param)=>{
    return apiPostRequest('/lechun-baseservice/portal/findCalendars',param)
}
/**
 * 获取TB项目
 * **/
export const getProjects = (param)=>{
    return apiPostRequest('/lechun-bi/tb/getProjects',param)
}
/**
 * 获取TB字段
 * **/
export const getFields = (param)=>{
    return apiPostRequest('/lechun-bi/tb/getField',param)
}
/**OA**/
/**
 * 获取问卷项目列表
 * **/
export const getSurveyProjectList = (param)=>{
    return apiPostRequest('/lechun-baseservice/survey/getProjectList',param)
}/**
 * 获取问卷项目树形列表
 * **/
export const getSurveyProjectTreeList = (param)=>{
    return apiPostRequest('/lechun-baseservice/survey/getProjectOptionList',param)
}
/**
 * 获取问卷项目
 * **/
export const getSurveyProject = (param)=>{
    return apiGetRequest('/lechun-baseservice/survey/getProject',param)
}
/**
 * 保存问卷项目
 * **/
export const saveSurveyProject = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/survey/createProject',param)
}/**
 * 复制问卷项目
 * **/
export const copySurveyProject = (param)=>{
    return apiPostRequest('/lechun-baseservice/survey/copyProject',param)
}
/**
 * 删除问卷项目
 * **/
export const delSurveyProject = (param)=>{
    return apiPostRequest('/lechun-baseservice/survey/deleteProject',param)
}
/**
 * 获取问卷答题页
 * **/
export const getSurveyPage = (param)=>{
    return apiGetRequest('/lechun-baseservice/survey/loadProject',param)
}
/**
 * 提交问卷答题页
 * **/
export const submitSurveyPage = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/survey/saveAnswer',param)
}
/**
 * 获取360分类
 * **/
export const get360ClassList = (param)=>{
    return apiGetRequest('/lechun-baseservice/eval/getClassList',param)
}
/**
 * 保存360分类
 * **/
export const save360ClassList = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/eval/saveClass',param)
}
/**
 * 获取360字典
 * **/
export const get360DicList = (param)=>{
    return apiGetRequest('/lechun-baseservice/eval/getEvalDicList',param)
}
/**
 * 获取360用户人员
 * **/
export const get360ClassUserList = (param)=>{
    return apiGetRequest('/lechun-baseservice/eval/getClassUserList',param)
}
/**
 * 保存360用户人员
 * **/
export const save360ClassUser = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/eval/addClassUser',param)
}
/**
 * 删除360用户人员
 * **/
export const del360ClassUser = (param)=>{
    return apiPostRequest('/lechun-baseservice/eval/deleteClass',param)
}
/**
 * 获取360问卷问题
 * **/
export const get360SurveyQaList = (param)=>{
    return apiGetRequest('/lechun-baseservice/survey/getSurveyQuestionOption',param)
}
/**
 * 获取360关联问卷列表
 * **/
export const get360ConnectSurveyList = (param)=>{
    return apiGetRequest('/lechun-baseservice/eval/getProjectRefList',param)
}
/**
 * 获取360问卷配置
 * **/
export const get360SurveySetting = (param)=>{
    return apiGetRequest('/lechun-baseservice/eval/getEval',param)
}
/**
 * 保存360问卷配置
 * **/
export const save360SurveySetting = (param)=>{
    return apiPostRequest('/lechun-baseservice/eval/saveEval',param)
}
/**
 * 保存360关联问卷列表
 * **/
export const save360ConnectSurveyList = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/eval/saveProjectRef',param)
}
/**
 * 获取下级KPI列表
 * **/
export const getSubordinateKpiList = (param)=>{
    return apiGetRequest('/lechun-baseservice/kpi/subKpis',param)
}
/**
 * 获取下级月度KPI可选月份
 * **/
export const getSubordinateKpiPeriods = (param)=>{
    return apiGetRequest('/lechun-baseservice/kpi/subKpiPeriods',param)
}
/**
 * KPI评分人配置-列表
 * **/
export const getKpiRaterConfigList = (param)=>{
    return apiGetRequest('/lechun-baseservice/kpi/raterConfig/list',param)
}
/**
 * KPI评分人配置-保存(新增/编辑)
 * **/
export const saveKpiRaterConfig = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/kpi/raterConfig/save',param)
}
/**
 * KPI评分人配置-启用/停用
 * **/
export const toggleKpiRaterConfigStatus = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/kpi/raterConfig/toggleStatus',param)
}
/**
 * 获取KPI详情
 * **/
export const getSubordinateKpiDetail = (param)=>{
    return apiGetRequest('/lechun-baseservice/kpi/myKpi',param)
}
/**
 * 保存kpi
 * **/
export const saveSubordinateKpi = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/kpi/saveKpi',param)
}
/**
 * 发布kpi
 * **/
export const publishSubordinateKpi = (param)=>{
    return apiPostRequest('/lechun-baseservice/kpi/publishKpi',param)
}
/**
 * 发布kpi
 * **/
export const returnPublishSubordinateKpi = (param)=>{
    return apiPostRequest('/lechun-baseservice/kpi/reEdit',param)
}/**
 * 发布kpi
 * **/
export const returnHrPublishSubordinateKpi = (param)=>{
    return apiPostRequest('/lechun-baseservice/kpi/hrReEdit',param)
}
/**
 * 确认
 * **/
export const ensureSubordinateKpi = (param)=>{
    return apiGetRequest('/lechun-baseservice/kpi/ensureMyKpi',param)
}
/**
 * 退回KPI
 * **/
export const returnBackKpiSubordinateKpi = (param)=>{
    return apiGetRequest('/lechun-baseservice/kpi/turnBack',param)
}
/*
* 修改KPI填报方式
* */
export const changeKpiMakingType = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/kpi/changeKpiMakingType',param)
}
/*
* 获取新人之旅员工制定KPI方式列表
* */
export const getAllFreshJourneyUserMakeTypes = (param)=>{
    return apiGetRequest('/lechun-baseservice/kpi/getAllFreshJourneyUserMakeTypes',param)
}
/**
 * 绩效评估列表
 * **/
export const getPerformanceEvaList = (param)=>{
    return apiGetRequest('/lechun-baseservice/values/myValues',param)
}
/**
 * 保存绩效
 * **/
export const savePerformanceEva = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/values/saveValues',param)
}
/**
 * 清空Leader评分
 * **/
export const clearLeaderPerformanceRate = (param)=>{
    return apiPostRequest('/lechun-baseservice/values/clearLeaderRate',param)
}
/**
 * 清空自评评分
 * **/
export const clearSelfPerformanceRate = (param)=>{
    return apiPostRequest('/lechun-baseservice/values/clearSubRate',param)
}
/**
 * 删除部门leader
 * **/
export const clearPerformanceSuperLeader = (param)=>{
    return apiPostRequest('/lechun-baseservice/values/clearSuperLeader',param)
}
/**
 * 添加部门负责人
 * **/
export const appointSuperLeader = (param)=>{
    return apiPostRequest('/lechun-baseservice/values/appointSuperLeader',param)
}
/**
 * 360得分汇总列表
 * **/
export const getScoreResult360List = (param)=>{
    return apiGetRequest('/lechun-baseservice/eval/getEvalTotalList',param)
}
/**
 * 计算360得分
 * **/
export const computeScore360 = (param)=>{
    return apiPostRequest('/lechun-baseservice/eval/computeEvalResult',param)
}
/**
 * 确认360得分
 * **/
export const setConfirmScore360 = (param)=>{
    return apiPostRequest('/lechun-baseservice/eval/setComplete',param)
}
/**
 * 批量计算360得分
 * **/
export const computeAllScore360 = (param)=>{
    return apiPostRequest('/lechun-baseservice/eval/manualComputeEvalResult',param)
}
/**
 * 批量设置360结束时间
 * **/
export const setAll360EndTime = (param)=>{
    return apiPostRequest('/lechun-baseservice/eval/batchReChangeEndTime',param)
}
/**
 * 手工发放问卷
 * **/
export const send360survey = (param)=>{
    return apiPostRequest('/lechun-baseservice/eval/autoBuilderEvalProjectDistribute',param)
}
/**
 * 重置结束时间父列表
 * **/
export const resetUserSurveyEndTime = (param)=>{
    return apiPostRequest('/lechun-baseservice/eval/reChangeEndTimeByUser',param)
}
/**
 * 重置结束时间子列表
 * **/
export const resetSurveyEndTime = (param)=>{
    return apiPostRequest('/lechun-baseservice/eval/reChangeEndTime',param)
}
/**
 * 评分列表
 * **/
export const getScoreList = (param)=>{
    return apiGetRequest('/lechun-baseservice/eval/projectDistributeList',param)
}
/**
 * 评分列表
 * **/
export const getEvalScoreList = (param)=>{
    return apiGetRequest('/lechun-baseservice/eval/getEvalPersonTotalList',param)
}
/**
 * 下级评分列表
 * **/
export const getSubordinateScoreList = (param)=>{
    return apiGetRequest('/lechun-baseservice/eval/getEvalPersonSubList',param)
}
/**
 * 员工消息配置列表
 * **/
export const getOAMessageSysList = (param)=>{
    return apiGetRequest('/lechun-baseservice/sendConfig/getConfigList',param)
}
/**
 * 保存员工消息配置
 * **/
export const saveOAMessageSys = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/sendConfig/saveConfig',param)
}
/**
 * 员工管理列表
 * **/
export const getUserRefUsersList = (param)=>{
    return apiGetRequest('/lechun-baseservice/eval/getUserRefUsersList',param)
}
/**
 * 员工相关人列表
 * **/
export const getUserRefUsers = (param)=>{
    return apiGetRequest('/lechun-baseservice/eval/getUserRefUsers',param)
}
/**
 * 员工管理保存peers
 * **/
export const saveUserRefPeers = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/eval/addUserPeers',param)
}
/**
 * 员工管理保存peers
 * **/
export const saveInsertSurveyQuestion = (param)=>{
    return apiPostRequest('/lechun-baseservice/survey/insertModuleQuestion',param)
}
/**
 * 定期设置peers获取期次
 * **/
export const getUserPeersByPeriod = (param)=>{
    return apiGetRequest('/lechun-baseservice/eval/getUserPeersByPeriod',param)
}
/**
 * 定期设置peers获取期次
 * **/
export const copyLastPeriodPeers = (param)=>{
    return apiPostRequest('/lechun-baseservice/eval/copyLastPeriodPeers',param)
}
/**
 * sso配置列表（后台）
 * **/
export const getSsoDataList = (param)=>{
    return apiPostRequest('/lechun-baseservice/sso/getSSOList',param)
}
/**
 * sso配置保存（后台）
 * **/
export const saveSsoDataList = (param)=>{
    return apiPostRequest('/lechun-baseservice/sso/saveSSO',param)
}
/**
 * sso配置保存（后台）
 * **/
export const delSsoDataList = (param)=>{
    return apiPostRequest('/lechun-baseservice/sso/deleteSSO',param)
}
/**
 * 汇总报表
 * **/
export const getScoreResult = (param)=>{
    return apiGetRequest('/lechun-baseservice/scoreSum/sumList',param)
}
/**
 * 下载汇总报表
 * **/
export const downloadScoreResult = (param)=>{
    return downloadUrlRequest('/lechun-baseservice/scoreSum/sumExport',param)
}

/**
 * oa期次列表
 * **/
export const getEvalPeriodList = (param)=>{
    return apiGetRequest('/lechun-baseservice/eval/getEvalPeriodList',param)
}
/**
 * oa期次列表
 * **/
export const getEvalPeriodLogList = (param)=>{
    return apiGetRequest('/lechun-baseservice/eval/getDistributeLogPageList',param)
}
/*
* 修改KettlePassWord密码
* */
export const updateKettlePassWord = (param)=>{
    return apiPostRequest('/lechun-bi/kettle/updateKettlePassword',param)
}
/*
* 获取角色用户列表
* */
export const getRoleUserList = (param)=>{
    return apiGetRequest('/lechun-baseservice/role/getRoleUserList',param)
}
/*
* 保存角色用户
* */
export const saveRoleUser = (param)=>{
    return apiPostRequest('/lechun-baseservice/role/saveUserRole',param)
}
/*
* 获取scrm审核列表
* */
export const getMaterialCheckList = (param)=>{
    return apiGetRequest('/lechun-cms/scrmMaterial/getWaittingCheckMaterials',param)
}
/*
* 获取公告配置列表
* */
export const getAnnouncementList = (param)=>{
    return apiGetRequest('/lechun-baseservice/announcements/getAnnouncementList',param)
}
/*
* 保存公告配置
* */
export const saveAnnouncement = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/announcements/saveAnnouncement',param)
}
/*
* 获取日志列表
* */
export const getLogList = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/log/getLogList',param)
}
export const getLogSummary = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/log/getLogSummary',param)
}
/*获取业务数据管理列表
* */
export const getDataRightList = (param)=>{
    return apiGetRequest('/lechun-baseservice/dataRight/getDataPageList',param)
}
/*获取业务数据选项列表
* */
export const getDataRightOptionList = (param)=>{
    return apiGetRequest('/lechun-baseservice/dataRight/getDataBussOptional',param)
}
/*删除业务数据
* */
export const delDataRightItem = (param)=>{
    return apiGetRequest('/lechun-baseservice/dataRight/deleteData',param)
}
/*得到单条业务数据
* */
export const getDataRightItem = (param)=>{
    return apiGetRequest('/lechun-baseservice/dataRight/getDataSingle',param)
}
/*获取字段信息
* */
export const getFieldDataRight = (param)=>{
    return apiGetRequest('/lechun-baseservice/dataRight/getDataDetailListByAttachInfo',param)
}
/*保存单条业务数据
* */
export const saveDataRightItem = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/dataRight/saveData',param)
}
/*删除单条业务数据字段
* */
export const delDataRightItemField = (param)=>{
    return apiGetRequest('/lechun-baseservice/dataRight/deleteSingLeFieldData',param)
}
/*获取数据权限列表
* */
export const getUserRightDataList = (param)=>{
    return apiGetRequest('/lechun-baseservice/dataRight/getUserDataRightList',param)
}
/*删除用户权限
* */
export const deleteUserRightData = (param)=>{
    return apiGetRequest('/lechun-baseservice/dataRight/deleteUserDataRight',param)
}
/*获取数据权限options列表
* */
export const getUserRightOptionsList = (param)=>{
    return apiGetRequest('/lechun-baseservice/dataRight/getDataBussOptional',param)
}
/*获取数据权限options列表
* */
export const getRightUserList = (param)=>{
    return apiGetRequest('/lechun-baseservice/dataRight/getUserListByMenuId',param)
}
/*获取数据权限options列表
* */
export const saveUserRightData = (param)=>{
    return apiPostJsonRequest('/lechun-baseservice/dataRight/saveUserDataRight',param)
}
/*
* 获取预警分类列表
* */
export const getWarnTypesData = (param)=>{
    return apiGetRequest('/lechun-sales/bpWarn/getWarnTypes',param)
}
/*
* 获取大模型列表
* */
export const getModuleListData = (param)=>{
    return apiGetRequest('/lechun-ai/app/getBailianModule',param)
}
/*
* 获取大模型列表
* */
export const createWarnSqlByAI = (param)=>{
    return apiPostJsonRequest('/lechun-sales/bpWarn/createWarnSqlByAI',param)
}
/*
* 获取预览数据
* */
export const getPreviewData = (param)=>{
    return apiPostJsonRequest('/lechun-sales/bpWarn/previewData',param)
}
/*
* 获取预览数据
* */
export const getWorkFlowFormOptional = (param)=>{
    return apiGetRequest('lechun-baseservice/dingtalk/getWorkFlowFormOptional',param)
}

/**
 * 问数主题维护接口
 * **/
/*
* 新增或修改问数主题
* */
export const saveOrUpdateWenshuTopic = (param)=>{
    return apiPostRequest('/lechun-baseservice/wenshuTopic/saveOrUpdateWenshuTopic',param)
}
/*
* 新增问数主题
* */
export const saveWenshuTopic = (param)=>{
    return apiPostRequest('/lechun-baseservice/wenshuTopic/saveWenshuTopic',param)
}
/*
* 修改问数主题
* */
export const updateWenshuTopic = (param)=>{
    return apiPostRequest('/lechun-baseservice/wenshuTopic/updateWenshuTopic',param)
}
/*
* 删除问数主题
* */
export const deleteWenshuTopic = (param)=>{
    return apiPostRequest('/lechun-baseservice/wenshuTopic/deleteWenshuTopic',param)
}
/*
* 分页查询问数主题列表
* */
export const getWenshuTopicList = (param)=>{
    return apiGetRequest('/lechun-baseservice/wenshuTopic/getWenshuTopicList',param)
}
/*
* 根据ID查询问数主题
* */
export const getWenshuTopic = (param)=>{
    return apiGetRequest('/lechun-baseservice/wenshuTopic/getWenshuTopic',param)
}
/*
* 获取所有有效问数主题
* */
export const getAllWenshuTopics = (param)=>{
    return apiGetRequest('/lechun-baseservice/wenshuTopic/getAllWenshuTopics',param)
}

/*
* 获取主题的库表树和已选表
* */
export const getTopicTables = (param)=>{
    return apiGetRequest('/lechun-baseservice/wenshuTopic/getTopicTables',param)
}
/*
* 保存主题涉及的表
* */
export const saveTopicTables = (param)=>{
    return apiPostRequest('/lechun-baseservice/wenshuTopic/saveTopicTables',param)
}

/**
 * 角色问数主题配置接口
 * **/
/*
* 查看角色已配置的问数主题
* */
export const getRoleWenshuTopics = (param)=>{
    return apiGetRequest('/lechun-baseservice/role/getRoleWenshuTopics',param)
}
/*
* 保存/修改角色的问数主题配置
* */
export const saveRoleWenshuTopics = (param)=>{
    return apiPostRequest('/lechun-baseservice/role/saveRoleWenshuTopics',param)
}
/*
* 删除角色的问数主题配置
* */
export const deleteRoleWenshuTopic = (param)=>{
    return apiPostRequest('/lechun-baseservice/role/deleteRoleWenshuTopic',param)
}
/*
* 清空角色的所有问数主题
* */
export const clearRoleWenshuTopics = (param)=>{
    return apiPostRequest('/lechun-baseservice/role/clearRoleWenshuTopics',param)
}

/**
 * MCP 服务权限配置接口
 * **/
export const getAllMcpServices = (param)=>{
    return apiGetRequest('/lechun-baseservice/role/getAllMcpServices',param)
}
export const getRoleMcpServices = (param)=>{
    return apiGetRequest('/lechun-baseservice/role/getRoleMcpServices',param)
}
export const saveRoleMcpServices = (param)=>{
    return apiPostRequest('/lechun-baseservice/role/saveRoleMcpServices',param)
}
export const clearRoleMcpServices = (param)=>{
    return apiPostRequest('/lechun-baseservice/role/clearRoleMcpServices',param)
}

/**
 * API 权限配置接口
 * **/
export const getAllApis = (param)=>{
    return apiGetRequest('/lechun-baseservice/role/getAllApis',param)
}
export const getRoleApis = (param)=>{
    return apiGetRequest('/lechun-baseservice/role/getRoleApis',param)
}
export const saveRoleApis = (param)=>{
    return apiPostRequest('/lechun-baseservice/role/saveRoleApis',param)
}
export const clearRoleApis = (param)=>{
    return apiPostRequest('/lechun-baseservice/role/clearRoleApis',param)
}

/**
 * Vibe 页面权限配置
 */
export const getVibeAppList = (param) =>
    apiGetRequest('/lechun-baseservice/vibeAdmin/pageAccess/projects', param)

export const saveVibeAppAccessType = (param) =>
    apiPostJsonRequest('/lechun-baseservice/vibeAdmin/app/accessType/save', param)

export const saveVibeAppPortalVisible = (param) =>
    apiPostJsonRequest('/lechun-baseservice/vibeAdmin/app/portalVisible/save', param)

export const getVibePageAccessRoutes = (param) =>
    apiGetRequest('/lechun-baseservice/vibeAdmin/pageAccess/routes', param)

export const saveVibePagePermission = (param) =>
    apiPostJsonRequest('/lechun-baseservice/vibeAdmin/pageAccess/savePermission', param)

export const getVibePageAccessAudit = (param) =>
    apiGetRequest('/lechun-baseservice/vibeAdmin/pageAccess/audit', param)

// 项目负责人自助配置；后端逐接口校验 owner_user_id，不依赖管理员权限。
export const getVibeOwnerAccessProjects = () =>
    apiGetRequest('/lechun-baseservice/vibeProject/ownerAccess/projects', {})
export const getVibeOwnerAccessContext = (param) =>
    apiGetRequest('/lechun-baseservice/vibeProject/ownerAccess/context', param)
export const getVibeOwnerAccessStatus = (param) =>
    apiGetRequest('/lechun-baseservice/vibeProject/ownerAccess/status', param)
export const saveVibeOwnerPagePermission = (param) =>
    apiPostJsonRequest('/lechun-baseservice/vibeProject/routes/savePermission', param)

/**
 * 用户问数主题查询接口
 * **/
/*
* 获取当前用户的问数主题
* */
export const getUserWenshuTopics = (param)=>{
    return apiGetRequest('/lechun-baseservice/user/getUserWenshuTopics',param)
}
/*
* 获取指定用户的问数主题
* */
export const getUserWenshuTopicsByUserId = (param)=>{
    return apiGetRequest('/lechun-baseservice/user/getUserWenshuTopicsByUserId',param)
}
export const getUserMcpServicesByUserId = (param)=>{
    return apiGetRequest('/lechun-baseservice/user/getUserMcpServicesByUserId',param)
}

/**
 * API Key 管理（lechun-mcp 服务）
 * **/
/*
* 获取API Key列表 — GET /lechun-mcp/api/credential
* 后端从登录 Session 自动获取当前用户，无需传任何参数
* */
export const getApiCredentialList = (param)=>{
    return apiGetRequest('/lechun-mcp/api/credential',param)
}
/*
* 创建API Key — POST /lechun-mcp/api/credential
* */
export const createApiCredential = (param)=>{
    return apiPostJsonRequest('/lechun-mcp/api/credential',param)
}
/*
* 禁用API Key — PUT /lechun-mcp/api/credential/{id}/disable
* */
export const disableApiCredential = (param)=>{
    return apiPutRequest(`/lechun-mcp/api/credential/${param.id}/disable`,{})
}
/*
* 启用API Key — PUT /lechun-mcp/api/credential/{id}/enable
* */
export const enableApiCredential = (param)=>{
    return apiPutRequest(`/lechun-mcp/api/credential/${param.id}/enable`,{})
}
/*
* 删除API Key — DELETE /lechun-mcp/api/credential/{id}
* */
export const deleteApiCredential = (param)=>{
    return apiDeleteRequest(`/lechun-mcp/api/credential/${param.id}`)
}
/*
* 刷新 (轮换) API Key — PUT /lechun-mcp/api/credential/{id}/refresh
* */
export const refreshApiCredential = (param)=>{
    return apiPutRequest(`/lechun-mcp/api/credential/${param.id}/refresh`,{})
}
/*
* 续期免登录 — PUT /lechun-mcp/api/credential/{id}/autoLogin/renew
* */
export const renewApiCredentialAutoLogin = (param)=>{
    return apiPutRequest(`/lechun-mcp/api/credential/${param.id}/autoLogin/renew`,{})
}
/*
* 立即失效免登录 — PUT /lechun-mcp/api/credential/{id}/autoLogin/revoke
* */
export const revokeApiCredentialAutoLogin = (param)=>{
    return apiPutRequest(`/lechun-mcp/api/credential/${param.id}/autoLogin/revoke`,{})
}

/*
* 获取API Key调用审计日志 — GET /lechun-mcp/api/credential/auditLogs（后端待实现）
* */
export const getApiCredentialAuditLogs = (param)=>{
    return apiGetRequest('/lechun-mcp/api/credential/auditLogs',param)
}

// ==================== MCP 服务管理  /api/mcp/config ====================
export const getMcpServiceList = (param) => apiGetRequest('/lechun-mcp/api/mcp/config/services', param)
export const saveMcpService = (param) => apiPostJsonRequest('/lechun-mcp/api/mcp/config/services', param)
export const updateMcpService = (param) => apiPutRequest(`/lechun-mcp/api/mcp/config/services/${param.id}`, param)
// 后端无 DELETE，映射到 disable
export const deleteMcpService = (param) => apiPutRequest(`/lechun-mcp/api/mcp/config/services/${param.id}/disable`, {})
export const getMallMcpServices = (param) => apiGetRequest('/lechun-mcp/api/mcp/mall/services', param)
export const getMallMcpServiceDetail = (param) => apiGetRequest(`/lechun-mcp/api/mcp/mall/services/${param.id}`, {})
export const getMallApiList = (param) => apiGetRequest('/lechun-mcp/api/mcp/mall/apis', param)
export const getMallApiDetail = (param) => apiGetRequest(`/lechun-mcp/api/mcp/mall/apis/${param.id}`, {})
export const getMallSkillList = (param) => apiGetRequest('/lechun-ai/skill/mall/list', param)
export const getMallSkillDetail = (param) => apiGetRequest('/lechun-ai/skill/mall/detail', param)
export const createSkillInstallTask = (param) => apiGetRequest('/lechun-ai/skill/install/createTask', param)

// ==================== API 注册中心  /api/mcp/registry ====================
export const batchDeleteApiRegistry = (param) => apiPostRequest("/lechun-mcp/api/mcp/registry/batch/delete", param)
export const getApiRegistryList = (param) => apiGetRequest('/lechun-mcp/api/mcp/registry', param)
export const saveApiRegistry = (param) => apiPostJsonRequest('/lechun-mcp/api/mcp/registry', param)
export const updateApiRegistry = (param) => apiPutRequest(`/lechun-mcp/api/mcp/registry/${param.id}`, param)
export const getApiRegistryImpact = (param) => apiGetRequest(`/lechun-mcp/api/mcp/registry/${param.id}/impact`, {})
export const enableApiRegistry = (param) => apiPutRequest(`/lechun-mcp/api/mcp/registry/${param.id}/enable`, {})
// 后端无 DELETE，映射到 disable
export const deleteApiRegistry = (param) => apiPutRequest(`/lechun-mcp/api/mcp/registry/${param.id}/disable`, {})

// ==================== MCP 工具管理  /api/mcp/config ====================
export const getMcpToolList = (param) => apiGetRequest('/lechun-mcp/api/mcp/config/tools', param)
export const getMcpToolDetail = (param) => apiGetRequest(`/lechun-mcp/api/mcp/config/tools/${param.toolId}`, {})
export const saveMcpTool = (param) => apiPostJsonRequest('/lechun-mcp/api/mcp/config/tools', param)
export const createToolCombo = (param) => apiPostJsonRequest('/lechun-mcp/api/mcp/config/tool-combo', param)
export const updateMcpTool = (param) => apiPutRequest(`/lechun-mcp/api/mcp/config/tools/${param.id}`, param)
// 发布：先 saveVersion 拿到 versionId，再调 publish；当前前端合并为一步，对齐到 saveVersion
export const publishMcpTool = (param) => apiPostJsonRequest(`/lechun-mcp/api/mcp/config/tools/${param.id}/versions`, param)
export const getMcpToolVersionList = (param) => apiGetRequest(`/lechun-mcp/api/mcp/config/tools/${param.toolId}/versions`, {})
export const getMcpToolPublishedSpec = (param) => apiGetRequest(`/lechun-mcp/api/mcp/config/versions/${param.versionId}/spec`, {})
export const saveMcpToolVersion = (param) => apiPostJsonRequest(`/lechun-mcp/api/mcp/config/tools/${param.toolId}/versions`, param)
export const getMcpToolVersionDetail = (param) => apiGetRequest(`/lechun-mcp/api/mcp/config/versions/${param.versionId}`, {})
export const validateMcpToolVersion = (param) => apiPostRequest(`/lechun-mcp/api/mcp/config/versions/${param.versionId}/validate`, {})
export const testMcpToolVersion = (param) => apiPostRequest(`/lechun-mcp/api/mcp/config/versions/${param.versionId}/test`, {})
export const publishMcpToolVersion = (param) => apiPostJsonRequest(`/lechun-mcp/api/mcp/config/versions/${param.versionId}/publish`, param)
export const debugManagedMcpToolRequest = (param) => apiPostJsonRequest('/lechun-mcp/api/mcp/config/debug/http', param)
export const getMcpToolPublishLogs = (param) => apiGetRequest(`/lechun-mcp/api/mcp/config/versions/${param.versionId}/publishLogs`, {})
export const rollbackMcpToolVersion = (param) => apiPostRequest(`/lechun-mcp/api/mcp/config/tools/${param.toolId}/rollback?targetVersion=${encodeURIComponent(param.targetVersion)}`, {})


/**
 * 常用SQL-保存
 * **/
export const saveCommonSql = (param)=>{
    return apiPostJsonRequest('/lechun-bi/commonSql/save',param)
}

/**
 * 常用SQL-分页列表
 * **/
export const getCommonSqlPageList = (param)=>{
    return apiGetRequest('/lechun-bi/commonSql/pageList',param)
}

/**
 * 常用SQL-详情
 * **/
export const getCommonSqlDetail = (param)=>{
    return apiGetRequest('/lechun-bi/commonSql/detail',param)
}

/**
 * 常用SQL-更新
 * **/
export const updateCommonSql = (param)=>{
    return apiPostJsonRequest('/lechun-bi/commonSql/update',param)
}

/**
 * 常用SQL-更新状态
 * **/
export const updateCommonSqlStatus = (param)=>{
    return apiPostRequest('/lechun-bi/commonSql/updateStatus',param)
}

/**
 * 常用SQL-删除
 * **/
export const deleteCommonSql = (param)=>{
    return apiPostRequest('/lechun-bi/commonSql/delete',param)
}

// ==================== Vibe 管理 ====================
export const getVibeAdminAppList = (param) => apiGetRequest('/lechun-baseservice/vibeAdmin/app/list', param)
export const getVibeAdminDepartments = (param) => apiGetRequest('/lechun-baseservice/vibeAdmin/app/departments', param)
export const createVibeAdminApp = (param) => apiPostJsonRequest('/lechun-baseservice/vibeAdmin/app/create', param)
export const deleteVibeAdminApp = (param) => apiPostJsonRequest('/lechun-baseservice/vibeAdmin/app/delete', param)
export const getVibeAdminAppDetail = (param) => apiGetRequest('/lechun-baseservice/vibeAdmin/app/detail', param)
export const getVibeAdminProjectApis = (param) => apiGetRequest('/lechun-baseservice/vibeAdmin/app/apis', param)
export const saveVibeAdminProjectApis = (param) => apiPostJsonRequest('/lechun-baseservice/vibeAdmin/app/apis/save', param)
export const getVibeAdminAppHealth = (param) => apiGetRequest('/lechun-baseservice/vibeAdmin/app/health', param)
export const getVibeAdminProjectTables = (param) => apiGetRequest('/lechun-baseservice/vibeAdmin/app/tables', param)
export const getVibeAdminProjectTableData = (param) => apiGetRequest('/lechun-baseservice/vibeAdmin/app/tableData', param)
export const syncVibeAdminDatabaseReadme = (param) => apiPostJsonRequest('/lechun-baseservice/vibeAdmin/app/syncDatabaseReadme', param)
export const syncAllVibeAdminDatabaseReadme = (param) => apiPostJsonRequest('/lechun-baseservice/vibeAdmin/app/syncAllDatabaseReadme', param)
export const updateVibeAdminDatabaseReadme = (param) => apiPostJsonRequest('/lechun-baseservice/vibeAdmin/app/updateDatabaseReadme', param)
export const getVibeMysqlConnectionList = (param) => apiGetRequest('/lechun-baseservice/vibeAdmin/mysqlConnection/list', param)
export const saveVibeMysqlConnection = (param) => apiPostJsonRequest('/lechun-baseservice/vibeAdmin/mysqlConnection/save', param)
export const getVibeVisibleDictionary = (param) => apiGetRequest('/lechun-baseservice/vibeAdmin/dictionary/visible', param)
export const getVibeDbAccountList = (param) => apiGetRequest('/lechun-baseservice/vibeAdmin/account/list', param)
export const getVibeDbAccountDetail = (param) => apiGetRequest('/lechun-baseservice/vibeAdmin/account/detail', param)
export const createVibeDbAccount = (param) => apiPostJsonRequest('/lechun-baseservice/vibeAdmin/account/create', param)
export const copyVibeDbAccount = (param) => apiPostJsonRequest('/lechun-baseservice/vibeAdmin/account/copy', param)
export const updateVibeDbAccountPermissions = (param) => apiPostJsonRequest('/lechun-baseservice/vibeAdmin/account/updatePermissions', param)
export const disableVibeDbAccount = (param) => apiPostJsonRequest('/lechun-baseservice/vibeAdmin/account/disable', param)
export const enableVibeDbAccount = (param) => apiPostJsonRequest('/lechun-baseservice/vibeAdmin/account/enable', param)
export const deleteVibeDbAccount = (param) => apiPostJsonRequest('/lechun-baseservice/vibeAdmin/account/delete', param)
export const getVibeDbGrantLogList = (param) => apiGetRequest('/lechun-baseservice/vibeAdmin/log/list', param)
export const generateVibeDbPrompt = (param) => apiPostJsonRequest('/lechun-baseservice/vibeAdmin/prompt/generate', param)
export const getVibeDeploymentPrompt = (param) => apiPostJsonRequest('/lechun-baseservice/vibeAdmin/prompt/deployment', param)
export const getVibeDbPromptTemplate = (param) => apiGetRequest('/lechun-baseservice/vibeAdmin/prompt/template', param)
export const saveVibeDbPromptTemplate = (param) => apiPostJsonRequest('/lechun-baseservice/vibeAdmin/prompt/template/save', param)
export const resetVibeDbPromptTemplate = (param) => apiPostJsonRequest('/lechun-baseservice/vibeAdmin/prompt/template/reset', param)

/*
* Codex 定时任务下发
* */
export const getCodexTaskList = (param) => apiGetRequest('/lechun-baseservice/codexTask/admin/list', param)
export const getCodexTaskDetail = (param) => apiGetRequest('/lechun-baseservice/codexTask/admin/detail', param)
export const createCodexTask = (param) => apiPostJsonRequest('/lechun-baseservice/codexTask/admin/create', param)
export const cancelCodexTask = (param) => apiPostJsonRequest('/lechun-baseservice/codexTask/admin/cancel', param)
export const requeueCodexTaskDelivery = (param) => apiPostJsonRequest('/lechun-baseservice/codexTask/admin/delivery/requeue', param)
export const getCodexTaskAutomationPrompt = (param) => apiGetRequest('/lechun-baseservice/codexTask/admin/automationPrompt', param)

// 2026-08-08 coder(lq): A2A 发布管理统一从 baseservice 读取，Portal 与桌面端只消费已发布内容。
export const getA2aReleaseOverview = () => apiGetRequest('/lechun-baseservice/a2a/admin/overview')
export const getA2aPortalOverview = () => apiGetRequest('/lechun-baseservice/a2a/portal/overview', { channel: 'stable' })
export const saveA2aPrompt = (param) => apiPostJsonRequest('/lechun-baseservice/a2a/admin/prompt/save', param)
export const saveCodexPlusRelease = (param) => apiPostJsonRequest('/lechun-baseservice/a2a/admin/release/save', param)
export const publishCodexPlusRelease = (param) => apiPostJsonRequest('/lechun-baseservice/a2a/admin/release/publish', param)
export const disableCodexPlusRelease = (param) => apiPostJsonRequest('/lechun-baseservice/a2a/admin/release/disable', param)
// 2026-08-14 coder(lq): A2A 模型白名单管理
export const saveA2aModel = (param) => apiPostJsonRequest('/lechun-baseservice/a2a/admin/model/save', param)
export const enableA2aModel = (param) => apiPostJsonRequest('/lechun-baseservice/a2a/admin/model/enable', param)
export const disableA2aModel = (param) => apiPostJsonRequest('/lechun-baseservice/a2a/admin/model/disable', param)
export const deleteA2aModel = (param) => apiPostJsonRequest('/lechun-baseservice/a2a/admin/model/delete', param)
export const uploadCodexPlusAsset = (releaseId, platform, file, onUploadProgress) => {
    const form = new FormData()
    form.append('releaseId', releaseId)
    form.append('platform', platform)
    form.append('file', file)
    return apiPostFormDataRequest('/lechun-baseservice/a2a/admin/release/asset/upload', form, {
        timeout: 0,
        onUploadProgress,
    })
}
